// UserContext.js
import { createContext } from "react";

const RoutersContext = createContext({});
export default RoutersContext;
